export default {
    'export': 'Exportar',
    'export-as-excel': 'Exportar a excel',
    'print-materials-tree': 'Imprimir árbol de artículos',
    warehouse: 'Almacén',
    'material-name-or-no': 'Número o nombre de artículo',
    'add': 'Añadir',
    'please-select-material': 'Eleja artículo',
}